<div class="match">
  @if (ready) {
    <header>
      <h3>
        @if (multi) {
          <span>Select your email</span>
        }
        @if (!multi) {
          <span>Is this your email?</span>
        }
      </h3>
      <p class="subheader">
        Based on the information provided, it looks like you may already have an account@if (multi) {
        <span>.</span>
      }
      @if (!multi) {
        <span> with the following email address</span>
      }
      @if (multi) {
        <span> Select your email to use the account.</span>
      }
    </p>
  </header>
}

<div role="content">
  @if (!ready) {
    <div>
      <se-fe-spinner
        [seFeDataSize]="900"
        [seFeDataInverted]="false"
        [seFeDataCenter]="true">
      </se-fe-spinner>
    </div>
  }
  @if (ready) {
    <div>
      <form
        [formGroup]="form"
        (ngSubmit)="submit()"
        [action]="actionUrl"
        method="POST"
        novalidate>
        <input type="hidden" name="authenticity_token" [value]="csrfToken">
        @if (multi) {
          <se-fe-form-field
          [seFeDataConfig]="{
            label: 'Confirm your email',
            hiddenLabel: true,
            errorMessages: { required: 'Please confirm your email.' }
          }">
            <se-fe-radios
              formControlName="selectedUser"
              [seFeDataOptions]="options">
            </se-fe-radios>
          </se-fe-form-field>
        }
        @if (!multi) {
          <h3 class="form-field">
            {{ options[0].label }}
          </h3>
        }
        <div class="form-field">
          <se-fe-button
            seFeDataEmphasis="high"
            seFeDataType="submit"
            [seFeDataIsLoading]="submitting"
            [seFeDataFullWidth]="true">
            @if (multi) {
              <span>Continue</span>
            }
            @if (!multi) {
              <span>Yes</span>
            }
          </se-fe-button>
          <se-fe-button
            seFeDataEmphasis="medium"
            seFeDataType="button"
            [seFeDataIsLoading]="submitting"
            [seFeDataFullWidth]="true"
            (click)="noMatch()">
            @if (multi) {
              <span>None of these are my email</span>
            }
            @if (!multi) {
              <span>No this is not my email</span>
            }
          </se-fe-button>
        </div>
      </form>
      <form [action]="actionUrl" method="POST" #signInForm>
        <input type="hidden" name="user[login]" [value]="form.value.selectedUser">
        <input type="hidden" name="user[user_duplicate_lookup_id]" [value]="store.dupes.id">
        <input type="hidden" name="authenticity_token" [value]="csrfToken">
      </form>
    </div>
  }
</div>
</div>
